import React from 'react'

import Base from '../_Base'

const RatingsDown = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M17,4 L5,4 L5,8 C5,8.155 4.964,8.309 4.895,8.447 L3.565,11.105 C3.285,11.666 3.285,12.334 3.565,12.895 L4.618,15 L10,15 C10.553,15 11,15.447 11,16 L11,20 C11,21.103 11.897,22 13,22 L14,22 L14,17.121 C14,16.053 14.416,15.049 15.172,14.293 C15.179,14.286 15.186,14.279 15.193,14.272 L17,12.568 L17,4 Z M18,2 C18.553,2 19,2.447 19,3 L19,13 C19,13.275 18.887,13.539 18.686,13.728 L16.577,15.717 C16.205,16.094 16,16.592 16,17.121 L16,23 C16,23.553 15.553,24 15,24 L13,24 C10.794,24 9,22.206 9,20 L9,17 L4.618,17 C3.854,17 3.169,16.576 2.829,15.894 L1.776,13.789 C1.216,12.669 1.216,11.331 1.776,10.211 L3,7.764 L3,4 C3,2.897 3.897,2 5,2 L18,2 Z M22,2.0625 C22.553,2.0625 23,2.5105 23,3.0625 L23,13.0005 C23,13.5525 22.553,14.0005 22,14.0005 C21.447,14.0005 21,13.5525 21,13.0005 L21,3.0625 C21,2.54992857 21.3854235,2.12703061 21.8832467,2.06923178 L22,2.0625 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default RatingsDown
